import axios from './Api';

export function UploadImportFile(data = new FormData(), options: Axios.IOptions = {}) {
  return axios.post<Aid.IAidImportFile>('/aids/importFile', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress
  });
}

export function GetImportStatus() {
  return axios.get<Aid.IAidImportStatus>('/aids/importFile/status');
}

export function GetImport(id = 0) {
  return axios.get<Aid.IAidImportResult>(`/aids/importFile/${id}`);
}

export function FinalizeImport(id = 0) {
  return axios.get<Aid.IAidFinalizeImport>(`/aids/importFile/${id}/import`);
}

export function GetImportErrorFile(id = 0) {
  return axios.get<Aid.IAidImportErrorFile>(`/aids/importFile/${id}/errorFile`, { responseType: 'blob' });
}

export function DeleteImport(id = 0) {
  return axios.delete(`/aids/importFile/${id}`);
}